import { useCallback } from 'react';
import useAvailableEmailTypes from './useAvailableEmailTypes';
export default function useGetAreEmailTypesAvailable() {
  const availableEmailTypes = useAvailableEmailTypes();
  return useCallback(emailTypes => {
    return emailTypes.every(type => availableEmailTypes.includes(type));
  }, [availableEmailTypes]);
}